;(function () {
  'use strict'

  angular.module('pub.collectibles.service', []).factory('CollectiblesService', CollectiblesService)

  /** @ngInject */
  function CollectiblesService($http, $q, API) {
    function getSetId(parentId) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'publisher/sets/' + parentId + '/collectibles')
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, '', 'error')
        })

      return defered.promise
    }

    function adminGetSetId(parentId) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'publisher/sets/' + parentId + '/collectibles')
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, '', 'error')
        })

      return defered.promise
    }

    function getChannelId(parentId) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'publisher/channels/' + parentId + '/collectibles')
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, '', 'error')
        })

      return defered.promise
    }

    function getId(parentId, id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'publisher/sets/' + parentId + '/collectibles/' + id)
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, '', 'error')
        })

      return defered.promise
    }

    function save(parentId, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/sets/' + parentId + '/collectibles', model)
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, '', 'error')
        })

      return defered.promise
    }

    function update(parentId, id, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/sets/' + parentId + '/collectibles/' + id, model)
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, '', 'error')
        })

      return defered.promise
    }

    function update2(parentId, id, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/sets/' + parentId + '/collectibles/' + id + '/update', model)
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, '', 'error')
        })

      return defered.promise
    }

    function remove(parentId, id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'publisher/sets/' + parentId + '/collectibles/' + id)
        .success(defered.resolve)
        .error(function (result) {
          if (result.error.message.indexOf('collectible_translations') !== -1) {
            swal('You must need remove translator first.', '', 'error')
            return
          }
          swal(result.error.message, '', 'error')
        })

      return defered.promise
    }

    function deleteAll(body) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/collectibles/delete_multiple', body)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function clearCache(body) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/collectibles/clear_cache', body)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function publish(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/collectibles/' + id + '/publish')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function unpublish(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/collectibles/' + id + '/unpublish')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function owned(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'collectibles/' + id + '/own')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function disown(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'collectibles/' + id + '/disown')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function saveShiny(collectibleId, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/collectibles/' + collectibleId + '/shinies', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function updateShiny(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'publisher/shinies/' + id, model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function publishShiny(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/shinies/' + id + '/publish')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function unpublishShiny(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/shinies/' + id + '/unpublish')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listTranslations(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'publisher/collectibles/' + id + '/collectible_translations')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function getTranslation(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'publisher/collectible_translations/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function createTranslation(id, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/collectibles/' + id + '/collectible_translations?automatic=true', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function updateTranslation(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'publisher/collectible_translations/' + id + '?automatic=true', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function removeTranslation(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'publisher/collectible_translations/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function getNumPrintsActiveUsers(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/collectibles/' + id + '/num_prints_by_active_users')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listProductCategories(start, limit) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'publisher/product_categories?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=id-asc',
        )
        .success(defered.resolve)

      return defered.promise
    }

    function getProductCategories(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/product_categories/' + id).success(defered.resolve)

      return defered.promise
    }

    function listProductSubCategories(parentId, start, limit) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/product_categories/' +
            parentId +
            '/product_subcategories?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=id-asc',
        )
        .success(defered.resolve)

      return defered.promise
    }

    function getProductSubCategories(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/product_subcategories/' + id).success(defered.resolve)

      return defered.promise
    }

    return {
      getSetId: getSetId,
      adminGetSetId: adminGetSetId,
      getChannelId: getChannelId,
      save: save,
      update: update,
      update2: update2,
      getId: getId,
      remove: remove,
      publish: publish,
      unpublish: unpublish,
      owned: owned,
      disown: disown,
      saveShiny: saveShiny,
      updateShiny: updateShiny,
      publishShiny: publishShiny,
      unpublishShiny: unpublishShiny,
      listTranslations: listTranslations,
      getTranslation: getTranslation,
      createTranslation: createTranslation,
      updateTranslation: updateTranslation,
      removeTranslation: removeTranslation,
      getNumPrintsActiveUsers: getNumPrintsActiveUsers,
      deleteAll: deleteAll,
      clearCache: clearCache,
      listProductCategories: listProductCategories,
      getProductCategories: getProductCategories,
      listProductSubCategories: listProductSubCategories,
      getProductSubCategories: getProductSubCategories,
    }
  }
})()
